import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import PortalUserList from "./PortalUserList";
import PortalUserSessionList from "./PortalUserSessionList";
import { ModuleRolePermissionsDto } from "../../../types/PortalUser";
import { MANAGEUSERSESSION } from "../../../utils/Constants";
import "./manage.scss";
import { useMenu } from "../../../context/MenuContext";
import { ModuleNames } from "../../../data/constants";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function Manage() {
  const [value, setValue] = React.useState(0);
  const { permissions } = useMenu();

  const [state, setState] = useState({
    portalModulePermissionsByRoleId: [] as ModuleRolePermissionsDto[],
    isInitialLoad: true,
    isUserDetailViewPermission: false,
    isUserDetailEditPermission: false,
    isUserSessionDetailViewPermission: false,
    isUserSessionDetailEditPermission: false,
  });

  const updateState = (newState: Partial<typeof state>) => {
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    const managePermission = permissions?.find(
      (permission) => permission.moduleName === ModuleNames.Manage
    );

    if (managePermission) {
      updateState({ isUserDetailViewPermission: managePermission.canView });
      updateState({ isUserDetailEditPermission: managePermission.canEdit });
      updateState({ isUserSessionDetailViewPermission: managePermission.canView });
      updateState({ isUserSessionDetailEditPermission: managePermission.canEdit });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <section className="mb-3">
        <Card>
          <CardContent>
            <Typography variant="h5" component="div" className="mb-3 card-title">{MANAGEUSERSESSION.TITLE}</Typography>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab
                label={MANAGEUSERSESSION.USERSTITLE}
                {...a11yProps(0)}
                disabled={!state.isUserDetailViewPermission}
              />
              <Tab
                label={MANAGEUSERSESSION.SESSIONSTITLE}
                {...a11yProps(1)}
                disabled={!state.isUserSessionDetailViewPermission}
              />
            </Tabs>
            {state.isUserDetailViewPermission ? (
              <CustomTabPanel value={value} index={0}>
                <PortalUserList isUserDetailEditPermission={state.isUserDetailEditPermission} />
              </CustomTabPanel>
            ) : (
              <CustomTabPanel value={value} index={0}></CustomTabPanel>
            )}
            {state.isUserDetailViewPermission ? (
              <CustomTabPanel value={value} index={1}>
                <PortalUserSessionList
                  isUserSessionDetailEditPermission={state.isUserSessionDetailEditPermission}
                />
              </CustomTabPanel>
            ) : (
              <CustomTabPanel value={value} index={0}></CustomTabPanel>
            )}
                </CardContent>
          </Card>
      </section>
    </>
  );
}
